import {takeEvery} from 'redux-saga/effects'
import {
  GET_STOCK_LEDGER,
  GET_STOCK_LEDGER_MOVEMENT_TYPES,
} from 'setup/redux/Actions/StockLedger/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_STOCK_LEDGER, fetchData)
  yield takeEvery(GET_STOCK_LEDGER_MOVEMENT_TYPES, fetchData)
}

export default dataSaga
